const PLATFORM_NAME = 'borrower-dashboard';

//Key es el nombre del resolver o mutation
export const SENTRY_GRAPHQL_FLOW_NAMES: any = {
  'login': {
    op: 'ui.flow.login',
    flowName: `${PLATFORM_NAME}.flow-login`
  },
  'CreateResponseTask': {
    op: 'ui.flow.create-response-task',
    flowName: `${PLATFORM_NAME}.flow-create-response-task`
  }
}